import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  Button,
  Spinner,
  NavLink,
  Form,
  Modal,
} from "react-bootstrap";
import { useParams, useNavigate, useLocation, Link } from "react-router-dom";
import {
  applyProduct_InquiryDetails,
  getItemCategoryActiveList,
  getProductActiveListByCategoryID,
} from "../MeldiDhamCRUD";
import { useTranslation } from "react-i18next";
import ElementPage from "../../Elements";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";

const CategoryProductList = () => {
  const { id } = useParams(); // category id
  const navigate = useNavigate();
  const location = useLocation();
  const { i18n } = useTranslation();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  /****************************************
   * Inquiry Modal
   *****************************************/
  const [showModal, setShowModal] = useState(false);
  const [productID, setProductID] = useState(0);
  const [productCategoryID, setProductCategoryID] = useState(0);
  const [productName, setProductName] = useState("");
  const [productCategoryName, setProductCategoryName] = useState("");
  const [categoryData, setCategoryData] = useState([]);
  const pathUrl = process.env.REACT_APP_API_URL;
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const [formData, setFormData] = useState({
    productID: 0,
    productCategoryID: 0,
    name: "",
    email: "",
    contact: "",
    message: "",
    terms: false,
  });

  useEffect(() => {
    loadCategories();

    if (id) {
      const categoryId = Number(id);

      setFormData((prev) => ({
        ...prev,
        productCategoryID: categoryId,
        productID: 0,
      }));

      getProductsData(categoryId);
    }
  }, [id]);

  const loadCategories = async () => {
    setLoading(true);
    try {
      const res = await getItemCategoryActiveList();
      if (res.data.isSuccess) {
        setCategoryData(res.data.responseObject);
      }
      // getProducts(0);
      setLoading(false);
    } catch (err) {
      console.error("Category fetch error:", err);
      setLoading(false);
    }
  };

  const getProductsData = async (categoryId) => {
    setLoading(true);
    try {
      const res = await getProductActiveListByCategoryID(categoryId);
      if (res.data.isSuccess) {
        setProducts(res.data.responseObject);
      } else {
        setProducts([]);
      }
    } catch (error) {
      console.error("Product load error:", error);
      setProducts([]);
    } finally {
      setLoading(false);
    }
  };

  const onSubmit = async (data) => {
    try {
      const res = await applyProduct_InquiryDetails(
        data.name,
        "",
        data.contact,
        data.message,
        "192.168.0.1",
        data.terms,
        1,
        0,
        1,
        productID,
        productCategoryID
      );
      if (res.data.isSuccess) {
        alert("Inquiry submitted successfully!");
        reset();
        setShowModal(false);
      } else {
        alert("Failed to submit inquiry.");
      }
    } catch (error) {
      console.error("Error submitting inquiry:", error);
    }
  };

  const getLocalized = (item, field) => {
    const lang = i18n.language;
    if (lang === "gu") return item[`${field}_GJ`] || item[field];
    if (lang === "hi") return item[`${field}_HN`] || item[field];
    return item[field];
  };

  const categoryName = location.state?.categoryName;

  const handleCloseModal = () => {
    reset();
    setShowModal(false);
  };

  const handleOpenModal = (
    selProductID,
    selProductName,
    selProductCategoryID,
    selProductCategoryName
  ) => {
    // console.log(" selProductID:", selProductID);
    // console.log(" selProductName:", selProductName);
    // console.log(" selProductCategoryID:", selProductCategoryID);
    // console.log(" selProductCategoryName:", selProductCategoryName);
    setProductName(selProductName);
    setProductCategoryName(selProductCategoryName);
    setProductID(selProductID);
    setProductCategoryID(selProductCategoryID);

    setFormData((prev) => ({
      ...prev,
      productCategoryID: selProductCategoryID,
      productID: selProductID,
    }));
    setShowModal(true);
  };
  const [hoveredId, setHoveredId] = useState(null);

  const isHover = hoveredId === hoveredId;
  return (
    <div className="py-4 px-4">
      <div className="mb-4">
        <div className="row">
          <div className="col-12">
            <div className="category-link-wrapper d-flex align-items-center px-4">
              <Link
                to="/page/categories"
                className="text-decoration-none justify-content-center text-dark me-2 badge bg-light px-3 py-2 rounded-3"
              >
                {categoryName || "Category Products"}
              </Link>
            </div>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="text-center my-5">
          <Spinner animation="border" />
        </div>
      ) : products.length === 0 ? (
        <p className="text-center text-muted">No products found</p>
      ) : (
        <Row className="g-4 mb-5">
          {products.map((prod) => {
            const isHover = hoveredId === prod.productID;

            return (
              <Col key={prod.productID} xs={12} sm={6} md={4} lg={3}>
                <Card
                  className="h-100 border-0 cursor-pointer"
                  style={{
                    borderRadius: "16px",
                    transition: "all 0.35s ease",
                    backgroundColor: "#ffffff",
                    boxShadow: isHover
                      ? "0 18px 40px rgba(0,0,0,0.16)"
                      : "0 8px 20px rgba(0,0,0,0.08)",
                    transform: isHover ? "translateY(-6px)" : "translateY(0)",
                    boxShadow:
                      hoveredId === prod.productID
                        ? "0 18px 40px rgba(0,0,0,0.16)"
                        : "0 8px 20px rgba(0,0,0,0.08)",
                    transform:
                      hoveredId === prod.productID
                        ? "translateY(-8px)"
                        : "translateY(0)",
                  }}
                  onMouseEnter={() => setHoveredId(prod.productID)}
                  onMouseLeave={() => setHoveredId(null)}
                  onClick={() => navigate(`/product/${prod.productID}`)}
                >
                  {/* IMAGE SECTION */}
                  <div
                    className="d-flex align-items-center justify-content-center position-relative"
                    style={{
                      // height: "230px",
                      height: "250px",
                      padding: "18px", // FIXED SPACING
                      // backgroundColor: "#f9fafb",
                      borderTopLeftRadius: "12px",
                      borderTopRightRadius: "12px",
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={pathUrl + prod.photoPath}
                      alt={"no-image"}
                      className="img-fluid"
                      style={{
                        maxWidth: "100vw",
                        maxHeight: "35vh",
                        objectFit: "cover",
                        transition: "transform 0.45s ease",
                        transform:
                          hoveredId === prod.productID
                            ? "scale(1.1)"
                            : "scale(1)",
                      }}
                    />{" "}
                    {isHover && (
                      <div
                        style={{
                          position: "absolute",
                          inset: 0,
                          background:
                            "linear-gradient(180deg, rgba(0,0,0,0.15), rgba(0,0,0,0.4))",
                        }}
                      />
                    )}
                  </div>

                  {/* PRODUCT DETAILS */}
                  <Card.Body
                    className="d-flex flex-column text-center"
                    style={{
                      padding: "14px",
                      backgroundColor: "#ffffff",
                    }}
                  >
                    <p
                      className="mb-3"
                      style={{
                        fontWeight: 600,
                        fontSize: "1rem",
                        color: "#1f2937",
                      }}
                    >
                      {getLocalized(prod, "productName")}
                    </p>

                    {/* ACTION BUTTONS */}
                    <div className="mt-auto d-flex gap-2">
                      <Button
                        className="w-100 fw-semibold"
                        size="sm"
                        style={{
                          backgroundColor: "#31572C",
                          border: "none",
                          borderRadius: "30px",
                          color: "#ffffff",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(`/product/${prod.productID}`);
                        }}
                      >
                        <i className="fas fa-eye me-1"></i> View
                      </Button>

                      <Button
                        className="w-100 fw-semibold"
                        size="sm"
                        style={{
                          backgroundColor: "#4F772D",
                          color: "#ffffff",
                          border: "none",
                          borderRadius: "30px",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleOpenModal(
                            prod.productID,
                            prod.productName,
                            prod.productCategoryID,
                            prod.productCategoryName
                          );
                        }}
                      >
                        Inquiry
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            );
          })}
        </Row>
      )}
      {/**********************************
       * Inquiry Modal
       ***********************************/}
      <Modal show={showModal} onHide={handleCloseModal} centered size="lg">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header closeButton>
            <Modal.Title className="text-yellow-500">
              Product Inquiry
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Select
                    value={formData.productCategoryID}
                    onChange={(e) => {
                      const selectedCatId = Number(e.target.value);
                      setFormData((prev) => ({
                        ...prev,
                        productCategoryID: selectedCatId,
                        productID: 0,
                      }));

                      getProductsData(selectedCatId);
                    }}
                    required
                  >
                    <option value={0}>-- Select Product Category --</option>
                    {categoryData.map((cate) => (
                      <option
                        key={cate.productCategoryID}
                        value={cate.productCategoryID}
                        selected={cate.productCategoryID === id ? true : false}
                        onChange={() => getProductsData(cate.productCategoryID)}
                      >
                        {/* {getLocalized(cate, "productCategoryName")} */}
                        {cate.productCategoryName}&nbsp;{" "}
                        {cate.productCategoryName_GJ} &nbsp;
                        {cate.productCategoryName_HN}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Select
                    value={formData.productID}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        productID: Number(e.target.value),
                      }))
                    }
                    required
                  >
                    <option value={0}>-- Select Product --</option>
                    {products.map((prod) => (
                      <option
                        key={prod.productID}
                        value={prod.productID}
                        selected={prod.productID === productID ? true : false}
                      >
                        {prod.productName}&nbsp; {prod.productName_GJ} &nbsp;
                        {prod.productName_HN}
                        {/* {getLocalized(prod, "productName")} */}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Control
                    {...register("name", { required: "Name is required" })}
                    placeholder="Enter your name"
                  />
                  {errors.name && (
                    <small className="text-danger">{errors.name.message}</small>
                  )}
                </Form.Group>

                {/* <Form.Group className="mb-3">
                        <Form.Control
                          type="email"
                          {...register("email")}
                          placeholder="Enter your email"
                        />
                      </Form.Group> */}

                <Form.Group className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Mobile number"
                    maxLength={10}
                    {...register("contact", {
                      required: "Mobile number is required",
                      minLength: { value: 10, message: "Must be 10 digits" },
                      maxLength: { value: 10, message: "Must be 10 digits" },
                      pattern: {
                        value: /^[0-9]+$/,
                        message: "Only numbers allowed",
                      },
                    })}
                    onInput={(e) => {
                      const value = e.target.value;
                      // If user typed any non-numeric character
                      if (/[^0-9]/.test(value)) {
                        toast.error("Only numbers are allowed");
                        e.target.value = value.replace(/[^0-9]/g, ""); // remove alphabets
                      }
                    }}
                  />
                  {errors.contact && (
                    <small className="text-danger">
                      {errors.contact.message}
                    </small>
                  )}
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3 h-100">
                  <Form.Control
                    as="textarea"
                    rows={8}
                    {...register("message", {
                      required: "Message is required",
                    })}
                    placeholder="Enter your message"
                  />
                  {errors.message && (
                    <small className="text-danger">
                      {errors.message.message}
                    </small>
                  )}
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col>
                <Form.Check
                  type="checkbox"
                  label="I agree to the terms and conditions"
                  {...register("terms", {
                    required: "You must accept the terms",
                  })}
                />
                {errors.terms && (
                  <small className="text-danger">{errors.terms.message}</small>
                )}
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              type="submit"
              style={{ backgroundColor: "#31572C", border: "none" }}
            >
              Submit
            </Button>
            <Button variant="danger" onClick={handleCloseModal}>
              Cancel
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
      <ElementPage />
    </div>
  );
};

export default CategoryProductList;
